import { getParamsUrl } from '@/helpers/request'
import Repository from './Repository'

const action = 'bids'
const routeHomeAdmin = 'pages/home-admin'
const routeHomeDriver = 'pages/home-driver'
const actionResp = 'responses'

export default {
  getHome({ search, cancelToken, ...reqParams }, isDriver) {
    const route = isDriver ? routeHomeDriver : routeHomeAdmin
    let params = getParamsUrl(reqParams || {})

    if (search?.value) {
      params += params ? '&' : '?'
      params += search.date
        ? `has_load_date=${search.value}`
        : `search=${search.value}`
    }

    return Repository.get(route + params, { cancelToken })
  },
  getHomeBid(reqParams = {}, isDriver) {
    let params = getParamsUrl(reqParams || {})

    if (!isDriver) {
      params += '&with_carrier_request=1'
    }
    const route = isDriver ? routeHomeDriver : routeHomeAdmin

    return Repository.get(route + params)
  },
  postBids(data) {
    return Repository.post(action, data)
  },
  putBids(id, data) {
    return Repository.put(action + '/' + id, data)
  },

  // TODO проверить роуты совместно с беком и удалить/оптимизировать
  getBidsKladrs() {
    return Repository.get('/bids/kladrs')
  },
  getBids(isArchive = false, isAdmin = false, page) {
    const expandForAdmin = isAdmin ? ',organization' : ''
    const archive = isArchive ? '&is_archive=1' : ''
    let params = `?expand=load-days,managers${expandForAdmin}${archive}`

    if (page && !isNaN(Number(page))) {
      params += `&page=${page}`
    }

    return Repository.get(action + params)
  },
  getBid(id, clean = false) {
    let params = clean ? '' : '?expand=load-days,auto'

    return Repository.get(`${action}/${id}${params}`)
  },
  getPromoBids() {
    return Repository.get(action + '?future_days=1&expand=load-days')
  },
  setViewed(id) {
    return Repository.get(`${action}/${id}/view`)
  },
  patchBids(id, data) {
    return Repository.patch(action + '/' + id, data)
  },
  getCoordsByResponse(bidId, id) {
    return Repository.get(
      action + '/' + bidId + '/responses/' + id + '?expand=coords',
    ) // TODO нужна новая репа
  },
  getResponsesRequest(id, load_day_id = undefined) {
    const toExpand = [
      'load-day',
      'organization',
      'driver',
      'auto',
      'master-approve',
      'act-status',
      'ttn-status',
      'payment-status',
    ]
    let query = `${action}/${id}/${actionResp}?expand=${toExpand.join()}`

    if (load_day_id) {
      query += `&load_day_id=${load_day_id}`
    }

    return Repository.get(query)
  },
  getLoadDayResponsesRequest(loadDayId) {
    const toExpand = [
      'load-day',
      'organization',
      'driver',
      'auto',
      'master-approve',
      'act-status',
      'ttn-status',
      'payment-status',
      'user',
      'user-role',
    ]

    return Repository.get(
      actionResp + '?load_day_id=' + loadDayId + '&expand=' + toExpand.join(),
    )
  },
  getDeletedLoadDayResponsesRequest(loadDayId) {
    const toExpand = [
      'load-day',
      'organization',
      'driver',
      'auto',
      'master-approve',
      'act-status',
      'ttn-status',
      'payment-status',
      'user',
      'user-role',
    ]

    return Repository.get(
      actionResp +
        '?load_day_id=' +
        loadDayId +
        '&expand=' +
        toExpand.join() +
        '&is_deleted=1',
    )
  },
  deleteBidRequest(bid_id, id) {
    return Repository.delete(
      action + '/' + bid_id + '/' + actionResp + '/' + id,
    )
  },
  getStatsResponses(loadDayId) {
    return Repository.get(actionResp + '/stats?load_day_id=' + loadDayId)
  },
  sendNotification(id, data) {
    return Repository.post(`${action}/${id}/`, data)
  },
  changeSort(id, type) {
    return Repository.post(`${action}/${id}/order`, { action: type })
  },
  changeHotBid(item) {
    return Repository.post(`${action}/${item.id}/hot`, {
      hot: Number(item.hot),
    })
  },
  addBidToLP(item) {
    return Repository.put(`${action}/${item.id}`, {
      show_on_landing: Number(item.show_on_landing),
    })
  },
  calculate({ distance, load_point_kladr_id, unload_point_kladr_id }) {
    const params = `?distance=${distance}&kladr_load=${load_point_kladr_id}&kladr_unload=${unload_point_kladr_id}`

    return Repository.get(`${action}/requests${params}`)
  },
  setBidPaid(id) {
    return Repository.post(`${action}/${id}/toggle-is-paid`)
  },
}
